import React from "react";
const Spinner = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: "50", cy: "50", r: "45" }));
var SpinnerIcon_default = Spinner;
export {
  SpinnerIcon_default as default
};
//# sourceMappingURL=SpinnerIcon.js.map
